/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'conversation': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M34.936 27.137c.068.248-.064.354-.29.234l-3.445-1.806a11.87 11.87 0 0 1-3.49.515c-4.767 0-8.632-2.689-8.632-6.007 0-3.318 3.865-6.008 8.632-6.008 4.768 0 8.633 2.689 8.633 6.008 0 1.551-.851 2.958-2.236 4.024l.828 3.04zm-7.506.771c-5.705 0-10.173-3.299-10.173-7.512 0-.649.119-1.275.319-1.872-3.237.894-5.528 3.089-5.528 5.66 0 1.572.863 3.001 2.267 4.081l-.84 3.082c-.068.251.064.357.294.236l3.494-1.83c1.083.334 2.278.522 3.539.522 2.821 0 5.321-.934 6.92-2.376-.098.003-.194.009-.292.009z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/conversation.js